import { useContext, useEffect } from 'react';
import FormContext from '../../Form/FormContext.js';

function useFormReference(formFieldName, ref) {
    const formContext = useContext(FormContext);
    useEffect(() => {
        if (formFieldName && ref) {
            formContext.registerComponent(formFieldName, ref);
        }
        return () => {
            if (formFieldName) {
                formContext.unregisterComponent(formFieldName);
            }
        };
    }, [formContext, formFieldName, ref]);
}

export { useFormReference as default };
